(() => {
  const form = document.getElementById('ContactForm');

  if (!form || form.dataset.jiscContactEnhanced === 'true') {
    return;
  }

  form.dataset.jiscContactEnhanced = 'true';

  const successMessage = form.querySelector('[data-contact-form-success]');
  const inquiryType = form.querySelector('#ContactForm-inquiry-type');
  const productModel = form.querySelector('#ContactForm-product-model');
  const productOptions = form.querySelector('#ContactForm-product-options');

  const removeContactSuccessMarker = () => {
    const successUrl = new URL(window.location.href);

    if (!successUrl.searchParams.has('contact_posted')) {
      return;
    }

    successUrl.searchParams.delete('contact_posted');
    window.history.replaceState(window.history.state, '', successUrl.toString());
  };

  const scheduleContactSuccessMarkerCleanup = () => {
    const scheduleCleanup = () => {
      window.setTimeout(removeContactSuccessMarker, 5000);
    };

    if (document.readyState === 'complete') {
      scheduleCleanup();
      return;
    }

    window.addEventListener('load', scheduleCleanup, { once: true });
  };

  const publishContactSuccess = () => {
    if (
      !successMessage ||
      successMessage.dataset.contactEventFired === 'true' ||
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== 'function'
    ) {
      return false;
    }

    successMessage.dataset.contactEventFired = 'true';

    try {
      window.Shopify.analytics.publish('jisc_scanners:contact_form_submitted', {
        form_type: 'general_contact',
      });

      scheduleContactSuccessMarkerCleanup();

      return true;
    } catch (error) {
      delete successMessage.dataset.contactEventFired;
      return false;
    }
  };

  if (successMessage && !publishContactSuccess()) {
    window.addEventListener('load', publishContactSuccess, { once: true });
  }

  if (!productModel || !productOptions || productModel.value.trim() !== '') {
    return;
  }

  const scanner = new URL(window.location.href).searchParams.get('scanner');

  if (!scanner) {
    return;
  }

  const matchingOption = Array.from(productOptions.options).find((option) => option.value === scanner);

  if (!matchingOption) {
    return;
  }

  productModel.value = matchingOption.value;

  if (inquiryType && inquiryType.value === '') {
    inquiryType.value = 'Request a quote';
  }
})();
